import $ from 'jquery';

function getRandomClass() {
  const classes = ['is-circle', 'is-square', 'is-arch'];
  return classes[Math.floor(Math.random() * classes.length)];
}

$('.js-random').each((index, element) => {
  $(element).addClass(getRandomClass());
});
